import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { getMaterialBySlug } from "@/lib/materialMeta";
import { getLocationBySlug } from "@/lib/locationMeta";

export const Route = createFileRoute("/_app/rates/$materialSlug/$citySlug")({
  head: ({ params }) => {
    const material = getMaterialBySlug(params.materialSlug);
    const city = getLocationBySlug(params.citySlug);
    if (!material || !city) {
      return buildHead({
        title: "Scrap Metal Rates | LohaLink",
        description: "Live wholesale scrap metal rates across India.",
        canonical: `/rates/${params.materialSlug}/${params.citySlug}`,
      });
    }
    const canonical = `https://lohalink.in/rates/${material.slug}/${city.slug}`;
    const title = `${material.name} Scrap Price in ${city.name} Today | Live Rates - LohaLink`;
    const description = `Check today's live ${material.name} scrap rates in ${city.name}. AI-benchmarked price trend, GST-verified inventory from local yards, and escrow-backed deals.`;

    const jsonLdProduct = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: `${material.name} scrap in ${city.name}`,
      description: `Live ex-yard ${material.name} price in ${city.name}, ${city.state}. ${material.blurb}`,
      category: material.family,
      sku: `${material.slug}-${city.slug}`,
      brand: { "@type": "Brand", name: "LohaLink" },
    };
    const jsonLdBreadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://lohalink.in/" },
        { "@type": "ListItem", position: 2, name: "Live Rates", item: "https://lohalink.in/rates" },
        {
          "@type": "ListItem",
          position: 3,
          name: `${material.name} in ${city.name}`,
          item: canonical,
        },
      ],
    };

    return buildHead({
      title,
      description,
      canonical,
      jsonLd: [jsonLdProduct, jsonLdBreadcrumb],
    });
  },
  component: lazyRouteComponent(() => import("@/pages/RateMaterialCity")),
});
